<template>
  <div
    ref="searchContainerEl"
    class="search-container"
    :style="{ ...searchContainerElVarStyles }"
  >
    <IconMagnifyingGlass v-if="search.showIcon" />
    <input
      class="search"
      :class="{ '-with-icon': search.showIcon }"
      :style="searchElStyles"
      type="search"
      placeholder="Search for a position, location, role.."
    />
  </div>
</template>

<script>
import IconMagnifyingGlass from "../Icons/IconMagnifyingGlass.vue";
export default {
  name: "GlobalUISearch",
  components: {
    IconMagnifyingGlass,
  },
  props: {
    search: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    searchElStyles() {
      const { backgroundColor, isTransparent, textColor } = this.search;
      const styles = {
        // 9b is alpha 0.6 in 8 digit hex notation (00 - ff) at 6.25 stops (6.25 * 16 = 100)
        backgroundColor: isTransparent
          ? backgroundColor.value + "9b"
          : backgroundColor.value,
        color: textColor.value,
      };
      return styles;
    },
    searchContainerElVarStyles() {
      const { placeholderColor } = this.search;

      return {
        "--placeholder-color": placeholderColor.value,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.search-container {
  --placeholder-color: white;
  --svg-size: 25px;
  --base-search-padding-horizontal: 24px;
  --base-search-padding-vertical: 17px;
  --svg-right-padding: 12px;
  --padding-left-with-icon: calc(
    var(--base-search-padding-horizontal) + var(--svg-size) +
      var(--svg-right-padding)
  );

  position: relative;
  width: 100%;

  svg#icon-magnifying-glass {
    position: absolute;
    z-index: 1;
    top: 50%;
    left: var(--base-search-padding-horizontal);
    transform: translateY(-47%);

    width: var(--svg-size);
    height: var(--svg-size);

    fill: var(--placeholder-color);
  }

  .search {
    gap: 12px;

    /* input structure and spacing props */
    width: 100%;
    padding: var(--base-search-padding-vertical)
      var(--base-search-padding-horizontal);

    border: 1px solid rgb(0 0 0 / 3%);
    border-radius: 40px;
    box-shadow:
      0 1px 2px 0 rgb(0 0 0 / 5%),
      0 4px 12px 0 rgb(0 0 0 / 5%);

    @include mobile {
      --base-search-padding-vertical: 12px;
    }

    &.-with-icon {
      padding-left: var(--padding-left-with-icon);
    }

    &:active,
    &:focus {
      outline: none;
    }

    &::placeholder {
      opacity: 0.85;
    }

    &,
    &::placeholder {
      font-size: var(--cr-font-size-placeholder-desktop);
      font-style: normal;
      line-height: 21px;

      /* input and placeholder text props */
      color: var(--placeholder-color);
      letter-spacing: var(--cr-letter-spacing-placeholder-desktop);

      @include laptop {
        font-size: var(--cr-font-size-placeholder-tablet);
        line-height: 19px;
        letter-spacing: var(--cr-letter-spacing-placeholder-tablet);
      }

      @include mobile {
        font-size: var(--cr-font-size-placeholder-mobile);
        line-height: 17px;
        letter-spacing: var(--cr-letter-spacing-placeholder-mobile);
      }
    }
  }
}
</style>
